import { Link } from "react-router-dom";
import {
  facebook,
  linkedin,
  tiktok,
  twitter,
  whatsapp,
} from "../assets/icons/index";
import { HOME_PATH } from "../Routes/paths";
import { useTranslation } from "react-i18next";

interface FooterProps {}

const Footer = ({}: FooterProps) => {
  const { i18n, t } = useTranslation();
  return (
    <section
      className={`w-full  bg-[#F5F5F5] flex flex-col items-center  ${
        i18n.language === "en" ? "font-Poppins" : "font-Almarai"
      }`}
    >
      <div className="my-[40px] w-[90%] lg:w-[80%] pb-[20px] border-b-[1px] flex items-center justify-between">
        <Link to={HOME_PATH}>
          <img src="../images/footerlogo.png" alt="" />
        </Link>
        <div className="flex  items-center gap-4">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/profile.php?id=61563989890756"
          >
            <img
              className="w-[10px] hover:scale-125 duration-150 cursor-pointer"
              src={facebook}
              alt=""
            />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/onyxcom-tech-6ba269337/"
          >
            <img
              className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
              src={linkedin}
              alt=""
            />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://wa.me/+971524344578"
          >
            <img
              className="w-[18px] hover:scale-125 duration-150 cursor-pointer"
              src={whatsapp}
              alt=""
            />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.tiktok.com/@onyxcomtech?lang=en"
          >
            <img
              className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
              src={tiktok}
              alt=""
            />
          </a>

          <a target="_blank" rel="noreferrer" href="https://x.com/OnyxcomTech">
            {" "}
            <img
              className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
              src={twitter}
              alt=""
            />
          </a>
        </div>
      </div>
      <p className="mb-[20px] text-[14px] text-[#4C4C4C] flex items-center justify-center">
        {t("© 2024 ONYXCOM For Technology. All Rights Reserved")}
      </p>
    </section>
  );
};

export default Footer;
